import React from "react";

import LSBdDisplay03 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { useRecoilState } from "recoil";
import {
  onboardingState,
  onboardingUserTagState,
} from "../../../store/onboardingState";
import useDisplay from "../../../hooks/useDisplay";

const Step04 = ({ style }) => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);

  const [onboardingUserTagStateAtom, setOnboardingUserTagStateAtom] =
    useRecoilState(onboardingUserTagState);

  const questionList11 = [
    {
      title: "📚 지식",
      value: "지식",
    },
    {
      title: "💰 대출",
      value: "대출 기초,대출 중급",
    },
    {
      title: "💼 직장인",
      value: "직장인",
    },
    {
      title: "🧑‍💼 사업자",
      value: "사업자",
    },
    {
      title: "🏡 부동산",
      value: "부동산 기초,부동산 중급",
    },
    {
      title: "📈 재테크",
      value: "재테크 기초,재테크 중급",
    },
    {
      title: "🏦 실전",
      value: "실전",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        flex: 1,
        ...style,
      }}
    >
      <img
        style={{
          height: "auto",
          width: "100%",
          marginBottom: isMobile ? 30 : 50,
        }}
        src="/assets/images/onboarding02.png"
        alt="onboarding02"
      />

      <LSBdDisplay03
        style={{
          color: "#000000",
          marginBottom: 16,
          fontSize: isMobile ? 20 : 32,
          lineHeight: isMobile ? "28px" : "44.8px",
        }}
      >
        관심 카테고리를 선택해 주세요
      </LSBdDisplay03>
      <LSRgH2HeadLine
        style={{
          color: "#000000",
          marginBottom: isMobile ? 30 : 66,
          fontSize: isMobile ? 14 : 18,
          lineHeight: isMobile ? "19.6px" : "25.2px",
        }}
      >
        답변을 기반으로 관심 있는 카테고리의 강의만 모아서 추천해 드릴게요!
      </LSRgH2HeadLine>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: isSmall ? "space-between" : "flex-start",
          flexWrap: "wrap",
          gap: isMobile ? "10px" : "16px 24px",
        }}
      >
        {questionList11.map((item, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border:
                  onboardingStateAtom.question11 &&
                  onboardingStateAtom.question11.some(
                    (item02) => item02 === item.title
                  )
                    ? "none"
                    : "1px solid #A4A8B1",
                background:
                  onboardingStateAtom.question11 &&
                  onboardingStateAtom.question11.some(
                    (item02) => item02 === item.title
                  )
                    ? "#5050FF"
                    : "#fff",
                borderRadius: 12,
                width: isMobile ? "46.6%" : isTablet ? "30%" : 200,
                height: isMobile ? 41 : 45,
                cursor: "pointer",
              }}
              onClick={() => {
                if (onboardingStateAtom?.question11) {
                  if (
                    onboardingStateAtom.question11.some(
                      (item02) => item02 === item.title
                    )
                  ) {
                    let temp = onboardingStateAtom.question11.filter(
                      (item02) => item02 !== item.title
                    );
                    setOnboardingStateAtom({
                      ...onboardingStateAtom,
                      question11: temp,
                    });

                    let temp02 = (
                      onboardingUserTagStateAtom.question11 ?? []
                    ).filter((item02) => item02 !== item.value);
                    setOnboardingUserTagStateAtom({
                      ...onboardingUserTagStateAtom,
                      question11: temp02,
                    });
                  } else {
                    setOnboardingStateAtom({
                      ...onboardingStateAtom,
                      question11: [
                        ...onboardingStateAtom.question11,
                        item.title,
                      ],
                    });
                    setOnboardingUserTagStateAtom({
                      ...onboardingUserTagStateAtom,
                      question11: [
                        ...(onboardingUserTagStateAtom.question11 ?? []),
                        item.value,
                      ],
                    });
                  }
                } else {
                  setOnboardingStateAtom({
                    ...onboardingStateAtom,
                    question11: [item.title],
                  });
                  setOnboardingUserTagStateAtom({
                    ...onboardingUserTagStateAtom,
                    question11: [item.value],
                  });
                }
              }}
            >
              <LSRgH2HeadLine
                style={{
                  color:
                    onboardingStateAtom.question11 &&
                    onboardingStateAtom.question11.some(
                      (item02) => item02 === item.title
                    )
                      ? "#ffffff"
                      : "#A4A8B1",
                  fontSize: isMobile ? 15 : 18,
                  lineHeight: isMobile ? "21px" : "25.2px",
                }}
              >
                {item.title}
              </LSRgH2HeadLine>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Step04;
